import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ClerkProvider, SignedIn, SignedOut, RedirectToSignIn, useUser } from "@clerk/clerk-react";
import Homepage from "./HomePage";
import DropdownProvider from "./DropdownProvider";
import UploadEmailForm from "./UploadEmailForm";
import Thanks from "./Thanks";
import DropdownLayout from "./DropdownLayout";
import AccessCode from "./AccessCode";
import DropdownPage from "./DropdownPage";
import SuccessPage from "./SuccessPage";
import LoginPage from "./LoginPage";
import AdminPage from "./AdminPage";

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

function UserSync() {
  const { isLoaded, isSignedIn, user } = useUser();
  useEffect(() => {
    if (!isLoaded || !isSignedIn) return;
    fetch('/api/sync-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        clerkId: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName,
      }),
    }).catch(() => {});
  }, [isLoaded, isSignedIn, user]);
  return null;
}

function RequireAuth({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut><RedirectToSignIn /></SignedOut>
    </>
  );
}

const App = () => {
  // Workshop code session — separate from identity (Clerk handles who you are)
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => sessionStorage.getItem("isAuthenticated") === "true"
  );
  const [authCode, setAuthCode] = useState(
    () => sessionStorage.getItem("authCode") || ""
  );

  const handleSetAuthenticated = (value) => {
    sessionStorage.setItem("isAuthenticated", value);
    setIsAuthenticated(value);
  };

  const handleSetAuthCode = (code) => {
    sessionStorage.setItem("authCode", code);
    setAuthCode(code);
  };

  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <UserSync />
      <DropdownProvider>
        <Router>
          <Routes>
            <Route path="/sign-in" element={<LoginPage />} />
            <Route path="/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <AccessCode
                    setAuthenticated={handleSetAuthenticated}
                    setAuthCode={handleSetAuthCode}
                  />
                </RequireAuth>
              }
            />
            <Route
              path="/homepage"
              element={
                <RequireAuth>
                  {isAuthenticated
                    ? <Homepage authCode={authCode} />
                    : <Navigate to="/" replace />}
                </RequireAuth>
              }
            />
            <Route
              path="/form/:pageId"
              element={
                <RequireAuth>
                  <DropdownLayout />
                </RequireAuth>
              }
            >
              <Route path="" element={<DropdownPage />} />
            </Route>
            <Route
              path="/send-email"
              element={
                <RequireAuth>
                  <UploadEmailForm />
                </RequireAuth>
              }
            />
            <Route
              path="/Thanks"
              element={
                <RequireAuth>
                  <Thanks />
                </RequireAuth>
              }
            />
            <Route
              path="/Success"
              element={
                <RequireAuth>
                  <SuccessPage />
                </RequireAuth>
              }
            />
          </Routes>
        </Router>
      </DropdownProvider>
    </ClerkProvider>
  );
};

export default App;
